import { Component, EventEmitter, Input, Output } from '@angular/core';
import { faCloud } from '@fortawesome/free-solid-svg-icons';


@Component({
  selector: 'app-wizard-layout',
  templateUrl: './wizard-layout.component.html',
  styleUrls: ['./wizard-layout.component.sass']
})
export class WizardLayoutComponent {
  faCloud = faCloud;
  @Input() wizardTabs: string[];
  @Input() currentIndex = 0;
  @Input() disabledTabsIndex: number[];
  @Output() currentIndexEmitter = new EventEmitter<Number>();

  constructor() { }

  wizardButtonClick(tabIndex: number) {
    this.currentIndexEmitter.emit(tabIndex);
  }
}